import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './social-feeds.component.scss';
var SocialFeeds = /** @class */ (function (_super) {
    tslib_1.__extends(SocialFeeds, _super);
    function SocialFeeds(element) {
        return _super.call(this, element) || this;
    }
    SocialFeeds.prototype.init = function () {
        // window.addEventListener('resize', () => {
        // 	clearTimeout(this.timer);
        // 	let container: any = this.element.querySelector('.js-facebook-feed')
        // 	this.timer = setTimeout(()=>{
        // 			if(container) {
        // 				let containerHandler: any = container.getAttribute('data-facebook-handler')
        // 				container.innerHTML = `<div class="fb-page" data-href="https://www.facebook.com/${containerHandler}" data-tabs="timeline" data-width="500" data-height="400" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false">
        // 				<blockquote cite="https://www.facebook.com/${containerHandler}" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/${containerHandler}">Standard Bank - South Africa</a></blockquote></div></div>`;
        // 				FB.XFBML.parse();
        // 			}
        // 	}, 100);
        // })
    };
    SocialFeeds.prototype.bindEvents = function () {
    };
    return SocialFeeds;
}(Base));
export { SocialFeeds };



//////////////////
// WEBPACK FOOTER
// ./components/social-feeds/social-feeds.component.ts
// module id = 513
// module chunks = 0